<template>
  <div>
      <topTab :changeTabIndex='1'></topTab>
      <webpage></webpage>    
      <bottomMsg></bottomMsg>
  </div>
</template>

<script>
// @ is an alias to /src
import webpage from "@/components/web/web.vue"
import bottomMsg from "@/components/bottomMsg/bottomMsg.vue"
import topTab from "@/components/topTab/topTab.vue"
export default {
  name: 'home',
  components: {
    webpage,
    bottomMsg,
    topTab
  }
}
</script>
